import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { PositioningGroupComponent } from 'src/app/organization/positioning/components/positioning-group/positioning-group.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [PositioningGroupComponent],
  exports: [PositioningGroupComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
  ],
})
export class PositioningGroupModule {}
